var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86128 5.52925C3.12163 5.2689 3.54374 5.2689 3.80409 5.52925L7.99935 9.72451L12.1946 5.52925C12.455 5.2689 12.8771 5.2689 13.1374 5.52925C13.3978 5.7896 13.3978 6.21171 13.1374 6.47206L8.47075 11.1387C8.34573 11.2637 8.17616 11.334 7.99935 11.334C7.82254 11.334 7.65297 11.2637 7.52794 11.1387L2.86128 6.47206C2.60093 6.21171 2.60093 5.7896 2.86128 5.52925Z",
    fill: "#4A5564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown2);
export default __webpack_public_path__ + "static/media/chevron-down-2.667a4b6763806c27ed52a8ee5662212f.svg";
export { ForwardRef as ReactComponent };